import React, { FC } from "react";
import { useTranslation } from 'react-i18next';
import Modal from "Components/UI/Modal";
import Button from "Components/UI/Button";
import styles from "./ConfirmCloseModal.module.scss";

interface IConfirmCloseModal {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ConfirmCloseModal: FC<IConfirmCloseModal> = ({
  visible,
  onCancel,
  onConfirm,
}) => {
  const { t } = useTranslation('activities');
  const footerConfirmButtons = (
    <div className={styles['buttons']}>
      <Button
        onClick={onCancel}
        type="text"
        className={styles['buttonCancel']}
      >
        {t('closeModal.cancel')}
      </Button>
      <Button
        type="primary"
        htmlType="submit"
        onClick={onConfirm}
        className={styles['buttonSubmit']}
      >
        {t('closeModal.discard')}
      </Button>
    </div>
  );

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      footerButtons={footerConfirmButtons}
      footerActive={false}
      width={450}
      customClassName
    >
      <div className={styles['wrapper']}>
        <span className={styles['title']}>
          {t('closeModal.title')}
        </span>
        <hr className={styles['midleHr']} />
        <span className={styles['description']}>
          {t('closeModal.description')}
        </span>
      </div>
      <hr className={styles['footerHr']} />
    </Modal>
  )
}

export default ConfirmCloseModal;
